import React from "react"
import classnames from "classnames"
import * as cl from "./Plan.module.css"
import BrowserLink from "../BrowserLink/BrowserLink"

const Plan = ({
  wide,
  isYearly,
  className,
  theme,
  data: {
    name,
    description,
    options,
    badge,
    save,
    priceMonth,
    priceYear,
    payInfo,
    startButtonText,
    startButtonLink,
    buyLink: buyLinkData
  },
  ctaButtons = true,
  analyticsData,
}) => {
  let buyLink, startLink = startButtonLink;
  if (buyLinkData) {
    const { yearly, monthly } = buyLinkData
    buyLink = isYearly ? yearly : monthly;
  }
  if(typeof startButtonLink !== 'string') {
    const { yearly, monthly } = startButtonLink
    startLink = isYearly ? yearly : monthly;
  }

 
  return (
    <section className={classnames(cl.plan, cl[`plan_${theme}`], { [cl.plan_wide]: wide }, className)}>
      <span className={classnames(cl.badge, { [cl.hidden]: !isYearly || !badge })}>{isYearly && badge && badge}</span>

      <header className={cl.head}>
        <h3 className={cl.title}>{name}</h3>
        <span className={classnames(cl.save, { [cl.hidden]: !isYearly || !save })}>{isYearly && save && save}</span>
      </header>

      <p className={cl.description}>{description}</p>

      <div className={cl.options}>
        {options.map((section) => (
          <React.Fragment key={section.title}>
            <h4 className={cl.subTitle}>{section.title}</h4>

            <div className={cl.optionsLists}>
              {section.list.map((list, listI) => (
                <ul className={cl.list} key={listI}>
                  {list.map((item, itemI) => (
                    <li className={classnames(cl.listItem, { [cl.listItemDisabled]: !item.checked })} key={itemI}>{item.title}</li>
                  ))}
                </ul>
              ))}
            </div>
          </React.Fragment>
        ))}
      </div>

      <p className={classnames(cl.oldPrice, { [cl.hidden]: !isYearly })}>{isYearly && `${priceMonth}/month`}</p>
      <p className={cl.price}>
        {priceMonth || priceYear ? (
          <>
            {isYearly ? priceYear : priceMonth}
            <small>/month</small>
          </>
        ) : 'Free'}
      </p>

      <p className={cl.payInfo}>
        <span dangerouslySetInnerHTML={{ __html: typeof payInfo === 'string' ? payInfo : isYearly ? payInfo.yearly : payInfo.monthly }} />
      </p>

      {ctaButtons && (
        <>
          <BrowserLink
            href={startLink}
            target="_blank"
            rel="noreferrer"
            className={cl.startBtn}
            onClick={() => {
              // actid=7.2
              window.analytics?.track("button:click", {
                "button_name": typeof startButtonText === 'string' ? startButtonText : isYearly ? startButtonText.yearly : startButtonText.monthly,
                "parent_object_title": analyticsData.redirectionObjectTitle,
                "title": analyticsData.title,
                "url": startLink
              });
            }}
          >
            {typeof startButtonText === 'string' ? startButtonText : isYearly ? startButtonText.yearly : startButtonText.monthly}
          </BrowserLink>

          {buyLinkData && (
            <p className={cl.orBuy}>
              <span>or </span>
              <BrowserLink
                href={buyLink}
                target="_blank"
                rel="noreferrer"
                className={cl.buyLink}
                onClick={() => {
                  // actid=7.2
                  window.analytics?.track("button:click", {
                    "button_name": "buy now",
                    "parent_object_title": analyticsData.redirectionObjectTitle,
                    "title": analyticsData.title,
                    "url": buyLink
                  });
                }}
              >
                buy now
              </BrowserLink>
            </p>
          )}
        </>
      )}
    </section>
  )
}

export default Plan
